import React from 'react'

//Import the components and containers
import {Footer, Blog, Possibility, Features, WhatGPT3, Header} from "./containers";
import {CTA, Brand, Navbar} from "./components";

//Import the tyle
import "./App.css";

const App = () => {
    return (
        <div className="App">
            <div className="gradient__bg">
                <Navbar />
                <Header />
            </div>
            <Brand />
            <WhatGPT3 />
            <Features />
            <Possibility />
            <CTA />
            <Blog />
            <Footer />
        </div>
    )
}

export default App

/*
Notice:

--> We are importing from "index.js" files from each folder: components and containers
    so we are avoiding a million of lines of code INCREDIBLE !!!

--> We are using BEM CSS

*/